function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), React.createElement("g", {
  fill: "none"
}, React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "12",
  fill: "#87BBFD"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M19.14 4H10a2 2 0 00-2 2v1.5H2.3a.5.5 0 00-.47.3c-.35.85-.59 1.74-.72 2.64a.5.5 0 00.5.56H8v7c0 1.1.9 2 2 2h9.14a1 1 0 00.7-.29 11 11 0 000-15.42 1 1 0 00-.7-.29z"
}), React.createElement("path", {
  fill: "#556CD6",
  d: "M23.13 7.5H8V11h15.95c-.1-1.2-.37-2.38-.82-3.5z"
}))));